import { format } from "date-fns";
import { FormatterNumber } from "../../../../../utils/formatter";
import { ApiRestPost } from "../../../../../Helpers/ApiRestPost";
import { useState } from "react";
import { useEffect } from "react";
import { Spinner } from "../../../../shared";
import "../../../../shared/styles/UnifiedTable.css";

const TablaAtrasos = ({ data, onClick, onChange, sort, setSort }) => {
  const [loading, setLoading] = useState(false);
  const [seleccion, setSeleccion] = useState(null);
  const [seleccionSiguiente, setSeleccionSiguiente] = useState(null);

  useEffect(() => {
    const personaSeleccionada = localStorage.getItem("persona-seleccionada");
    if (personaSeleccionada) {
      setSeleccion(personaSeleccionada);
    }
  }, []);

  useEffect(() => {
    const personaSiguiente = localStorage.getItem("persona-siguiente");
    if (personaSiguiente) {
      setSeleccionSiguiente(personaSiguiente);
    }
  }, []);
  return (
    <div className="unified-table-container" style={{maxHeight: "70vh", overflowY: "auto"}}>
      <table className="unified-table">
        <thead>
          <tr>
            <th className="text-center"><div></div></th>
            <th className="text-center"><div>Nº</div></th>
            <th className="text-start">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                onClick={(event) =>
                  onClick(event, {
                    sort: sort == "-apellido" ? "apellido" : "-apellido",
                  })
                }
              >
                <span>Cliente</span>
                <i className={sort == "apellido" ? "bi bi-arrow-down ms-2" : "bi bi-arrow-up ms-2"}></i>
              </div>
            </th>
            <th className="text-start"><div>Teléfono</div></th>
            <th className="text-start">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                onClick={(event) =>
                  onClick(event, {
                    sort: sort == "-condicion" ? "condicion" : "-condicion",
                  })
                }
              >
                <span>Condición</span>
                <i className={sort == "condicion" ? "bi bi-arrow-down ms-2" : "bi bi-arrow-up ms-2"}></i>
              </div>
            </th>
            <th className="text-center"><div>Créditos al día</div></th>
            <th className="text-center">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                onClick={(event) =>
                  onClick(event, {
                    sort:
                      sort == "-cuotas_atrasadas_count"
                        ? "cuotas_atrasadas_count"
                        : "-cuotas_atrasadas_count",
                  })
                }
              >
                <span>Créditos atrasados</span>
                <i className={sort == "cuotas_atrasadas_count" ? "bi bi-arrow-down ms-2" : "bi bi-arrow-up ms-2"}></i>
              </div>
            </th>
            <th className="text-center">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                onClick={(event) =>
                  onClick(event, {
                    sort:
                      sort == "-ultimo_pago.created_at"
                        ? "ultimo_pago.created_at"
                        : "-ultimo_pago.created_at",
                  })
                }
              >
                <span>Fecha último pago</span>
                <i className={sort == "ultimo_pago.created_at" ? "bi bi-arrow-down ms-2" : "bi bi-arrow-up ms-2"}></i>
              </div>
            </th>
            <th className="text-end"><div>Deuda acumulada</div></th>
            <th className="text-center">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                onClick={(event) =>
                  onClick(event, {
                    sort:
                      sort == "-prescripcion.fecha_prescripcion"
                        ? "prescripcion.fecha_prescripcion"
                        : "-prescripcion.fecha_prescripcion",
                  })
                }
              >
                <span>Prescripción</span>
                <i className={sort == "prescripcion.fecha_prescripcion" ? "bi bi-arrow-down ms-2" : "bi bi-arrow-up ms-2"}></i>
              </div>
            </th>
            <th className="text-center"><div>Procesos</div></th>
          </tr>
        </thead>
        {!data ? (
          <tbody>
            <tr>
              <td colSpan={11} style={{ textAlign: 'center', padding: '40px' }}>
                <Spinner />
              </td>
            </tr>
          </tbody>
        ) : (
          <tbody>
            {data.map((p, index) => (
              <tr
                key={index}
                className={
                  seleccion == `${p.apellido} ${p.nombre}`
                    ? "selected"
                    : ""
                }
                style={{
                  boxShadow:
                    seleccion == `${p.apellido} ${p.nombre}`
                      ? "0 0 0 3px #0EA5E9"
                      : seleccionSiguiente == `${p.apellido} ${p.nombre}`
                      ? "0 0 0 2px #10B981"
                      : "",
                }}
                onClick={() => {
                  setSeleccion(`${p.apellido} ${p.nombre}`);
                  setSeleccionSiguiente(
                    `${data[index + 1]?.apellido} ${data[index + 1]?.nombre}`
                  );
                  localStorage.setItem(
                    "persona-seleccionada",
                    `${p.apellido} ${p.nombre}`
                  );
                  localStorage.setItem(
                    "persona-siguiente",
                    `${data[index + 1]?.apellido} ${data[index + 1]?.nombre}`
                  );
                }}
              >
                <td className="text-center">
                  <button
                    className="btn btn-sm"
                    style={{
                      background: 'linear-gradient(135deg, #0EA5E9 0%, #0284C7 100%)',
                      color: '#FFFFFF',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '6px 12px',
                      fontSize: '0.85rem',
                      fontWeight: '600',
                      whiteSpace: 'nowrap'
                    }}
                    data-bs-toggle="modal"
                    data-bs-target="#crear-gasto"
                    onClick={async () => {
                      setSeleccion(`${p.apellido} ${p.nombre}`);
                      setSeleccionSiguiente(
                        `${data[index + 1]?.apellido} ${
                          data[index + 1]?.nombre
                        }`
                      );
                      localStorage.setItem(
                        "persona-seleccionada",
                        `${p.apellido} ${p.nombre}`
                      );
                      localStorage.setItem(
                        "persona-siguiente",
                        `${data[index + 1]?.apellido} ${
                          data[index + 1]?.nombre
                        }`
                      );

                      let formData = new FormData();
                      formData.append("persona_id", p.id);
                      const response = await ApiRestPost({
                        url: "/personas/" + p.id + "/procesos",
                        setLoading: setLoading,
                        form: formData,
                      });

                      return (
                        (window.location.href =
                          "/gestion-mora/reportes-atrasos/editar/" + p.id),
                        "_blank"
                      );
                    }}
                  >
                    <i className="bi bi-plus-lg me-2"></i>Iniciar proceso
                  </button>
                </td>
                <td className="text-center">{p.id}</td>
                <td className="text-start">
                  <a
                    className="unified-table-link"
                    href={`/clientes/ver/${p.id}`}
                    target="_blank"
                  >
                    {p.apellido + " " + p.nombre}
                  </a>
                </td>
                <td className="text-start">
                  {p.contactos.length == 0
                    ? "-"
                    : p.contactos.map((c, idx) => (
                        <div key={idx}>{c.nro_telefono_prefix + "-" + c.nro_telefono}</div>
                      ))}
                </td>
                <td className="text-start">
                  {p.condiciones?.condicion ? (
                    <span>{p.condiciones?.condicion}</span>
                  ) : (
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      style={{ fontSize: "0.75rem", padding: '4px 8px' }}
                      onClick={() => {
                        return (
                          (window.location.href = "/clientes/editar/" + p.id),
                          "_blank"
                        );
                      }}
                    >
                      Ver condiciones
                    </button>
                  )}
                </td>
                <td className="text-center">
                  {p.deudaAcumulada.map((credito, idx) => {
                    if (credito.interes_punitorio == 0) {
                      return (
                        <a
                          key={idx}
                          className="unified-table-link d-block"
                          href={`/creditos/ver/${credito.credito_id}`}
                          target="_blank"
                        >
                          #{credito.credito_id}
                        </a>
                      );
                    }
                  })}
                </td>
                <td className="text-center">
                  {p.deudaAcumulada.map((credito, idx) => {
                    if (credito.interes_punitorio > 0) {
                      return (
                        <a
                          key={idx}
                          className="unified-table-link d-block"
                          href={`/creditos/ver/${credito.credito_id}`}
                          target="_blank"
                        >
                          #{credito.credito_id} / {credito.cuotas.filter((c) => c.deuda > 0).length}
                        </a>
                      );
                    }
                  })}
                </td>
                <td className="text-center">
                  {p.ultimoPago.map((pago, idx) => (
                    <div key={idx}>
                      {format(new Date(pago.created_at), "dd/MM/yyyy").toString()}
                    </div>
                  ))}
                </td>
                <td className="text-end">
                  <span className="unified-money">
                    {FormatterNumber(
                      p.deudaAcumulada.reduce(
                        (acc, credito) => acc + credito.deuda,
                        0
                      )
                    )}
                  </span>
                </td>
                <td className="text-center">
                  {p.deudaAcumulada.map((credito, idx) => {
                    if (credito.interes_punitorio > 0) {
                      return (
                        <a
                          key={idx}
                          className="unified-table-link d-block"
                          href={`/creditos/ver/${credito.credito_id}`}
                          target="_blank"
                        >
                          #{credito.credito_id} - {format(
                            new Date(credito.fecha_otorgamiento).setFullYear(new Date(credito.fecha_otorgamiento).getFullYear() + 3),
                            "dd/MM/yyyy"
                          ).toString()}
                        </a>
                      );
                    }
                  })}
                </td>
                <td className="text-center">
                  {p.procesos.map((proceso, idx) => (
                    <a
                      key={idx}
                      className="unified-table-link d-block"
                      href={
                        "/gestion-mora/reportes-atrasos/editar/" +
                        proceso.persona_id +
                        "/" +
                        proceso.id
                      }
                    >
                      #{proceso.id} {proceso.estado}
                    </a>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        )}
        <tfoot></tfoot>
      </table>
    </div>
  );
};

export default TablaAtrasos;
